export default `
    <div id="#= data.id #" class="#= data.classes# #=data.bsc||""#" style="#=data.style#" # if (data.disabled) { # disabled # } #>
        <ul>
            # for (var ii = 0; ii < data.tabs.length; ii++) { #
                <li 
                    # if (ii == 0) { # 
                         class="k-state-active"
                    # } 
                    if (data.tabs[ii].id) {#
                         id="#=data.tabs[ii].id#"
                    #}#
                >
                    #= z.ll(data.tabs[ii].label, true) #
                </li>
            # } #
        </ul>
        #= data.components #
    </div>
`;
